var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"page__header__back-btn"},[_c('icon',{attrs:{"icon":"chevron-left"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }